


















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class DragWrap extends Vue {
    @Prop({
        default() {
            return []
        },
    }) value!: any[];

    @Prop({
        default: ''
    }) draggingClass!: string;

    dropIndex: number = -1; // 投放位置的索引
    startIndex: number = -1; // 开始拖拽位置的索引

    get valueLength() {
        return this.value.length;
    }

    onDragStart(index, item, e) {
        this.startIndex = index;
    }

    onDragOver(index, item, e) {
        this.dropIndex = index;
        // 在第一个元素上禁止拖拽
        // 标记过不可移动的元素禁止禁止拖拽, 左固定的前一项没有禁止拖拽就还是可以拖拽
        if (index === 0 || !this.value[index].dragable && !(this.value[index - 1] && this.value[index - 1].dragable)) {
            this.dropIndex = this.startIndex;
        }
    }

    onDragLeave(index, item, e) {
        if (index === this.valueLength - 1) {
            // 在最后一个不可移动的元素上禁止拖拽
            if (!this.value[this.valueLength - 1].dragable) this.dropIndex = this.startIndex;
            else this.dropIndex = this.valueLength
        }
    }

    onDragEnd(index, item, e) {
        if (this.dropIndex !== index) {
            this.value.splice(this.dropIndex, 0, this.value[index]);
            this.value.splice(this.dropIndex > index ?index  : index + 1, 1);
            this.changeIndex(index);
            this.$emit('dragEnd', this.value)
        }
        this.dropIndex = -1
    }

    private changeIndex(index) {
        if (this.dropIndex > index) {
            const tempIndex = this.value[this.dropIndex - 1].index;
            for (let i = (this.dropIndex - 1); i > index; i--) {
                this.value[i].index = this.value[i - 1].index;
            }
            this.value[index].index = tempIndex;
        } else {
            const tempIndex = this.value[this.dropIndex].index;
            for (let i = this.dropIndex; i < index; i++) {
                this.value[i].index = this.value[i + 1].index;
            }
            this.value[index].index = tempIndex;
        }
        console.log(this.value);
    }
}
